/**
 * Import Dependency
 */
import { createAction } from 'redux-actions'
import * as ActionTypes from 'constants/actionType'

/**
 * Declare Variable
 */
const setFormAction = createAction(ActionTypes.SET_FORM)

/**
 * Export
 */
export const setForm = (params) => async (dispatch) => {
  try {
    dispatch(setFormAction(params))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/actions/components/form.js